export const CREATE_CONTACT_MESSAGE_REQUEST = "CREATE_CONTACT_MESSAGE_REQUEST";
export const CREATE_CONTACT_MESSAGE_SUCCESS = "CREATE_CONTACT_MESSAGE_SUCCESS";
export const CREATE_CONTACT_MESSAGE_ERROR = "CREATE_CONTACT_MESSAGE_ERROR";
